import { type AxiosResponse, isAxiosError } from 'axios';

type ErrorWithResponse = { response?: AxiosResponse | Record<string, unknown> };

export function handleInterceptError(error: unknown): Promise<unknown> {
  if (error instanceof Error && !isAxiosError(error)) {
    return Promise.reject(error);
  }
  // to ensure code that expects legacy errors works as expected we "unwrap" the actual error details that axios
  // returns nested under the "response" property.
  const errorWithResponse = error as ErrorWithResponse;
  return Promise.reject({ ...errorWithResponse, ...errorWithResponse.response });
}
